module.exports = __webpack_public_path__ + "static/media/fe_gym.2a07c46a.png";